export const mqlDefinition = (
  businessCountry?: string,
  businessMonthlyRevenue?: string,
): boolean => {
  // Disqualify UK under 10k businesses
  if (businessCountry === 'GB' && businessMonthlyRevenue === '0-10K') {
    return false;
  }
  // Everyone else is an MQL
  return true;
};
